export const normalizeStatusList = (payload) => {
  if (payload?.size) {
    return { status: payload.toArray() };
  }
  return undefined;
};

export const automatedJobQueryParams = ({
  jobsTeamSharingFeatureEnabled,
  organizationId,
  ownership = {},
  statusList,
  username,
}) => {
  if (jobsTeamSharingFeatureEnabled) {
    const defaultParams = {
      auto_only: true,
      full: true,
      limit: 50,
    };

    if (ownership.type === 'team') {
      return {
        ...defaultParams,
        team_id: ownership.name,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'organization') {
      return {
        ...defaultParams,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'user') {
      return {
        ...defaultParams,
        org_id: organizationId,
        owner: ownership.name || username,
        ...normalizeStatusList(statusList),
      };
    }

    return {
      ...defaultParams,
      ...normalizeStatusList(statusList),
    };
  }

  if (ownership.type === 'organization') {
    return {
      username,
      owner_type: ownership.type,
      ...normalizeStatusList(statusList),
      subaccounts: false,
    };
  }

  return {
    username,
    org_id: organizationId,
    owner: ownership.name || username,
    owner_type: 'user',
    subaccounts: false,
    ...normalizeStatusList(statusList),
  };
};
